module.exports = __webpack_public_path__ + "img/logo-infocert-positivo-no-border.603481e3.svg";